import React, { useState, useEffect } from "react";
import BaseHeader from "../Ui/Header/BaseHeader";

type Props = {
    mode: string;
}

const Header = ({mode }: Props) => {

    return (
        <BaseHeader
            links={[
                { name: "Главная", url: "/" },
                { name: "Торги", url: "/Category/Details" },
                { name: "Инвестиционный бутик", url: "/Boutique/Details" },
                { name: "Тарифы", url: "/articles/tariffs" },
                { name: "Контакты", url: "/Contacts/Index" },
                { name: "FAQ", url: "/faq" },
                mode == "Develop" && { name: "Тестовая страница", url: "/test"}
            ].filter(i => i)}
        />
    )
}

export default Header;